module.exports = __webpack_public_path__ + "static/media/view-app-grid-symbolic.19fbf4b3.svg";